'use client';

import type { ReactNode } from 'react';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { CartStep, useCartStepper } from '@eliadmin/core/src/hooks/cart/use-cart-stepper';
import { useLocalePathname } from '@eliadmin/core/src/hooks/use-locale-pathname';
import { arePathsEqual } from '@eliadmin/core/src/utils/url-utils';

/** The slim checkout header / footer belong to the steps after the cart and to the confirmation. */
export function useIsCheckoutChrome() {
  const pathname = useLocalePathname();
  const { currentStep } = useCartStepper();

  return (
    (arePathsEqual(pathname, ROUTES.CART()) && currentStep !== CartStep.DETAIL) ||
    arePathsEqual(pathname, ROUTES.ORDER_CONFIRM())
  );
}

/**
 * Chooses between the site header / footer (`children`) and the checkout ones (Figma „Header ·
 * Checkout header“ 60263:42602, „Footer - checkout“ 60257:23950) – both are rendered on the server,
 * the step lives in the URL (`?cs=`).
 */
export function CheckoutChrome({
  checkout,
  children,
}: {
  checkout: ReactNode;
  children: ReactNode;
}) {
  return useIsCheckoutChrome() ? checkout : children;
}
